import PublishIcon from '@mui/icons-material/Publish';
import { LoadingSkeleton, FormTitleBox, RESPONSIVE_CONFIG, ICONS_CONFIG } from '../../../common';
import { MESSAGES } from '../constants/generateCouponsConstants';

const FormHeader = ({onButtonClick, isLoading}) => {
  return (
    <FormTitleBox
      title={MESSAGES.GENERATION_TITLE}
      showButton={true}
      buttonText={MESSAGES.GENERATE_BUTTON}
      buttonIcon={PublishIcon}
      onButtonClick={onButtonClick}
      isLoading={isLoading}
      buttonProps={{
        sx: {
          fontSize: RESPONSIVE_CONFIG.HEADER.buttonFontSize,
          padding: RESPONSIVE_CONFIG.HEADER.buttonPadding,
        },
      }}
      iconProps={{
        sx: ICONS_CONFIG.PUBLISH,
      }}
    />
  );
};

export default FormHeader;
